var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"colofon-social-link",class:{ disabled: _vm.success },attrs:{"data-clipboard-text":_vm.href}},[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"colofon-social-link__succes",class:{ active: _vm.success }},[_vm._v("\n    De link is gekopieerd naar het klembord\n  ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07d1ef41","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ColofonSocialLink.vue
// module id = null
// module chunks = 